import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BOUNCY_SUMS_MOTIVATIONAL_MESSAGE_KEYS } from '@/features/bouncySums/constants';

import type { BouncySumsLabels } from '@/features/bouncySums/types';

export function useBouncySumsLabels(): BouncySumsLabels {
	const { t } = useTranslation();

	return useMemo<BouncySumsLabels>(
		() => ({
			audioToggleTooltip: t('bouncy_sums.audio_toggle.tooltip'),
			bpmLabel: t('bouncy_sums.hud.bpm'),
			endTitle: t('bouncy_sums.end_screen.title'),
			motivationalMessages: BOUNCY_SUMS_MOTIVATIONAL_MESSAGE_KEYS.map((key) =>
				t(`bouncy_sums.defaults.motivational_messages.${key}`),
			),
			otherTables: t('bouncy_sums.end_screen.other_tables'),
			playAll: t('bouncy_sums.start_screen.play_all'),
			playSelection: t('bouncy_sums.start_screen.play_selection'),
			previousHighScoreLabel: t('bouncy_sums.hud.previous_high_score'),
			replay: t('bouncy_sums.end_screen.replay'),
			scoreLabel: t('bouncy_sums.hud.score'),
			secondsSuffix: t('bouncy_sums.hud.seconds_suffix'),
			speedupMessage: t('bouncy_sums.defaults.speedup_message'),
			startTitle: t('bouncy_sums.start_screen.title'),
			tablesAnsweredLabel: t('bouncy_sums.end_screen.tables_answered'),
			tablesLabel: t('bouncy_sums.end_screen.tables'),
			tip: t('bouncy_sums.start_screen.tip'),
			topicTitle: t('bouncy_sums.defaults.topic_title'),
		}),
		[t],
	);
}
